// pages/KursSatisListPage.js - Detaylı hata mesajları eklenmiş versiyon
import React, { useState, useEffect, useRef } from 'react';
import axiosConfig from "../../../api/axiosConfig";
import SearchableSelect from './components/SearchableSelect';
import { parseMoneyInput, sanitizeMoneyInput } from "../../../utils/moneyUtils";

const odemeSikliklari = [
  { value: 'Aylık', label: 'Aylık' },
  { value: 'Yıllık', label: 'Yıllık' },
  { value: 'Tek Seferlik', label: 'Tek Seferlik' }
];

const KursSatisListPage = () => {
  const [kursSatislar, setKursSatislar] = useState([]);
  const [students, setStudents] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [lessonGroups, setLessonGroups] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [consultants, setConsultants] = useState([]);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [currentKursSatis, setCurrentKursSatis] = useState(null);
  const [loading, setLoading] = useState(false);
  
  // Sayfalama state'leri
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [dailySalesCount, setDailySalesCount] = useState(0);

  const [formData, setFormData] = useState({
    musteri_id: '',
    ogretmenler: [],
    dersler: [],
    odeme_sikligi: 'Aylık',
    varsayilan_odeme_kanali: '',
    ders_ucret: '',
    sirket_adi: '',
    sirket_payi: 0,
    danisman1: '',
    danisman2: '',
    danisman3: '',
    danisman1_payi: 0,
    danisman2_payi: 0,
    danisman3_payi: 0,
    notlar: '',
    status: 1  // Aktif/Pasif durumu (1: Aktif, 0: Pasif)
  });

  // Genişletilmiş filtre state'leri
  const [searchTerm, setSearchTerm] = useState('');
  const [filterOgrenci, setFilterOgrenci] = useState('');
  const [filterOgretmen, setFilterOgretmen] = useState('');
  const [filterDers, setFilterDers] = useState('');
  const [filterOdemeSekli, setFilterOdemeSekli] = useState('all');
  const [filterStatus, setFilterStatus] = useState('all'); // Status filtresi
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [selectedIds, setSelectedIds] = useState([]);

  // Dropdown state'leri
  const [showOgrenciDropdown, setShowOgrenciDropdown] = useState(false);
  const [showOgretmenDropdown, setShowOgretmenDropdown] = useState(false);
  const [showDersDropdown, setShowDersDropdown] = useState(false);
  const [showFilterOgretmenDropdown, setShowFilterOgretmenDropdown] = useState(false);
  const [showFilterDersDropdown, setShowFilterDersDropdown] = useState(false);
  
  // Form dropdown search states
  const [ogrenciSearchTerm, setOgrenciSearchTerm] = useState('');
  const [ogretmenSearchTerm, setOgretmenSearchTerm] = useState('');
  const [dersSearchTerm, setDersSearchTerm] = useState('');

  // Refs for click outside
  const ogrenciDropdownRef = useRef(null);
  const ogretmenDropdownRef = useRef(null);
  const dersDropdownRef = useRef(null);
  const filterOgretmenDropdownRef = useRef(null);
  const filterDersDropdownRef = useRef(null);

  useEffect(() => {
    fetchAllData();
  }, []);

  // Click outside handler
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ogrenciDropdownRef.current && !ogrenciDropdownRef.current.contains(event.target)) {
        setShowOgrenciDropdown(false);
      }
      if (ogretmenDropdownRef.current && !ogretmenDropdownRef.current.contains(event.target)) {
        setShowOgretmenDropdown(false);
      }
      if (dersDropdownRef.current && !dersDropdownRef.current.contains(event.target)) {
        setShowDersDropdown(false);
      }
      if (filterOgretmenDropdownRef.current && !filterOgretmenDropdownRef.current.contains(event.target)) {
        setShowFilterOgretmenDropdown(false);
      }
      if (filterDersDropdownRef.current && !filterDersDropdownRef.current.contains(event.target)) {
        setShowFilterDersDropdown(false);
      }
    };

    const handleEscKey = (event) => {
      if (event.key === 'Escape') {
        setShowOgrenciDropdown(false);
        setShowOgretmenDropdown(false);
        setShowDersDropdown(false);
        setShowFilterOgretmenDropdown(false);
        setShowFilterDersDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscKey);
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscKey);
    };
  }, []);

  const fetchAllData = async () => {
    setLoading(true);
    try {
      const [studentsRes, teachersRes, lessonsRes, companiesRes, consultantsRes, kursSatisRes, dailyCountRes] = await Promise.all([
        axiosConfig.get('/admin/ogrencis'),
        axiosConfig.get('/admin/teachers'),
        axiosConfig.get('/admin/dersgrubu'),
        axiosConfig.get('/admin/sirkets'),
        axiosConfig.get('/admin/danismans'),
        axiosConfig.get('/admin/kurssatis'),
        axiosConfig.get('/admin/kurssatis/daily-count').catch(() => ({ data: { count: 0 } }))
      ]);

      // API yanıtlarını güvenli şekilde işle
      let studentsData = [];
      if (Array.isArray(studentsRes.data)) {
        studentsData = studentsRes.data;
      } else if (studentsRes.data && Array.isArray(studentsRes.data.data)) {
        studentsData = studentsRes.data.data;
      } else if (studentsRes.data && Array.isArray(studentsRes.data.students)) {
        studentsData = studentsRes.data.students;
      }
      setStudents(studentsData);

      let teachersData = [];
      if (Array.isArray(teachersRes.data)) {
        teachersData = teachersRes.data;
      } else if (teachersRes.data && Array.isArray(teachersRes.data.data)) {
        teachersData = teachersRes.data.data;
      } else if (teachersRes.data && Array.isArray(teachersRes.data.teachers)) {
        teachersData = teachersRes.data.teachers;
      }
      setTeachers(teachersData);

      let lessonsData = [];
      if (Array.isArray(lessonsRes.data)) {
        lessonsData = lessonsRes.data;
      } else if (lessonsRes.data && Array.isArray(lessonsRes.data.data)) {
        lessonsData = lessonsRes.data.data;
      }
      setLessonGroups(lessonsData);

      let companiesData = [];
      if (Array.isArray(companiesRes.data)) {
        companiesData = companiesRes.data;
      } else if (companiesRes.data && Array.isArray(companiesRes.data.data)) {
        companiesData = companiesRes.data.data;
      }
      setCompanies(companiesData);

      let consultantsData = [];
      if (Array.isArray(consultantsRes.data)) {
        consultantsData = consultantsRes.data;
      } else if (consultantsRes.data && Array.isArray(consultantsRes.data.data)) {
        consultantsData = consultantsRes.data.data;
      }
      setConsultants(consultantsData);

      let kursSatisData = [];
      if (Array.isArray(kursSatisRes.data)) {
        kursSatisData = kursSatisRes.data;
      } else if (kursSatisRes.data && Array.isArray(kursSatisRes.data.data)) {
        kursSatisData = kursSatisRes.data.data;
      } else if (kursSatisRes.data && Array.isArray(kursSatisRes.data.kurssatis)) {
        kursSatisData = kursSatisRes.data.kurssatis;
      }
      
      // Debug için konsola yazdır
      console.log('🔵 Kurs Satış Verileri Yüklendi:');
      console.log('- Toplam kayıt:', kursSatisData.length);
      console.log('- Aktif kayıtlar:', kursSatisData.filter(k => parseInt(k.status) === 1).length);
      console.log('- Pasif kayıtlar:', kursSatisData.filter(k => parseInt(k.status) === 0).length);
      console.log('- Tüm veriler:', kursSatisData);
      
      // 🔍 DEBUG: Mila SARI kontrolü
      const milaSari = studentsData.find(s => s.name && s.name.includes('Mila') && s.name.includes('SARI'));
      if (milaSari) {
        console.log('🌟 Mila SARI bulundu:', milaSari);
        const milaninKurslari = kursSatisData.filter(k => k.musteri_id == milaSari.id);
        console.log(`📊 Mila'nın kurs sayısı: ${milaninKurslari.length}`);
        console.log('📄 Mila ID tipi:', typeof milaSari.id);
        console.log('📄 İlk kurs musteri_id tipi:', typeof kursSatisData[0]?.musteri_id);
        if (milaninKurslari.length > 0) {
          console.log('📦 Mila\'nın kursları:', milaninKurslari);
        } else {
          console.log('⚠️ Mila\'nın kursu YOK!');
          // Tüm musteri_id'leri kontrol et
          const tumMusteriIdler = kursSatisData.map(k => ({ id: k.musteri_id, type: typeof k.musteri_id, adi: k.musteri_adi }));
          console.log('🔍 Tüm müşteri ID\'leri (ilk 10):', tumMusteriIdler.slice(0, 10));
        }
      } else {
        console.log('⚠️ Mila SARI öğrenci listesinde bulunamadı!');
      }
      
      // Talha DEMIR'in ID'sini bul
      const talhaDemirOgrenci = studentsData.find(s => s.name && s.name.includes('Talha') && s.name.includes('DEMİR'));
      if (talhaDemirOgrenci) {
        console.log('🟢 Talha DEMİR bulundu:', talhaDemirOgrenci);
        const talhaninKurslari = kursSatisData.filter(k => k.musteri_id == talhaDemirOgrenci.id);
        console.log(`- Talha'nın kurs sayısı: ${talhaninKurslari.length}`, talhaninKurslari);
      }
      
      setKursSatislar(kursSatisData);
      setDailySalesCount(parseInt(dailyCountRes?.data?.count || 0, 10) || 0);
      
      // 🔴 DEBUG - ASIL SORUN BURADA
      console.log('❌❌❌ BACKEND\'DEN GELEN HAM VERİ SAYISI:', kursSatisData.length);
      console.log('İlk 5 kayıt:', kursSatisData.slice(0, 5));
      
    } catch (error) {
      console.error('Fetch error:', error);
      alert('Veriler yüklenirken bir hata oluştu.\n\nLütfen sayfayı yenileyip tekrar deneyin. Sorun devam ederse sistem yöneticisine başvurun.');
      // Hata durumunda boş array'ler set et
      setStudents([]);
      setTeachers([]);
      setLessonGroups([]);
      setCompanies([]);
      setConsultants([]);
      setKursSatislar([]);
      setDailySalesCount(0);
    } finally {
      setLoading(false);
      setSelectedIds([]);
    }
  };

  const openFormForCreate = () => {
    setCurrentKursSatis(null);
    setFormData({
      musteri_id: '',
      ogretmenler: [],
      dersler: [],
      odeme_sikligi: 'Aylık',
      varsayilan_odeme_kanali: '',
      ders_ucret: '',
      sirket_adi: '',
      sirket_payi: 0,
      danisman1: '',
      danisman2: '',
      danisman3: '',
      danisman1_payi: 0,
      danisman2_payi: 0,
      danisman3_payi: 0,
      notlar: '',
      status: 1
    });
    setOgrenciSearchTerm('');
    setOgretmenSearchTerm('');
    setDersSearchTerm('');
    setShowOgrenciDropdown(false);
    setShowOgretmenDropdown(false);
    setShowDersDropdown(false);
    setIsFormOpen(true);
  };

  const openFormForEdit = (kursSatis) => {
    console.log('Düzenleme için açılan kurs satış:', kursSatis);
    console.log('Mevcut status değeri:', kursSatis.status);
    setCurrentKursSatis(kursSatis);
    
    // Öğretmenler array kontrolü ve dönüşümü
    let ogretmenlerIds = [];
    if (Array.isArray(kursSatis.ogretmenler)) {
      ogretmenlerIds = kursSatis.ogretmenler.map(id => Number(id));
    }

    // Dersler array kontrolü ve dönüşümü
    let derslerIds = [];
    if (Array.isArray(kursSatis.dersler)) {
      derslerIds = kursSatis.dersler.map(id => Number(id));
    }

    // Şirket ID'sini bul - backend'den gelen şirket_adi string ise companies listesinden ID'sini bul
    let sirketId = '';
    if (kursSatis.sirket_id) {
      // Eğer direkt ID varsa kullan
      sirketId = kursSatis.sirket_id;
    } else if (kursSatis.sirket_adi) {
      // Eğer şirket adı varsa, companies listesinden ID'sini bul
      const sirket = companies.find(c => c.sirket_adi === kursSatis.sirket_adi);
      if (sirket) {
        sirketId = sirket.id;
      }
    }

    setFormData({
      musteri_id: kursSatis.musteri_id || '',
      ogretmenler: ogretmenlerIds,
      dersler: derslerIds,
      odeme_sikligi: kursSatis.odeme_sikligi || 'Aylık',
      varsayilan_odeme_kanali: kursSatis.varsayilan_odeme_kanali || '',
      ders_ucret: kursSatis.ders_ucret || '',
      sirket_adi: sirketId ? String(sirketId) : '',
      sirket_payi: kursSatis.sirket_payi || 0,
      danisman1: kursSatis.danisman1 || '',
      danisman2: kursSatis.danisman2 || '',
      danisman3: kursSatis.danisman3 || '',
      danisman1_payi: kursSatis.danisman1_payi || 0,
      danisman2_payi: kursSatis.danisman2_payi || 0,
      danisman3_payi: kursSatis.danisman3_payi || 0,
      notlar: kursSatis.notlar || '',
      status: kursSatis.status !== undefined ? parseInt(kursSatis.status) : 1
    });
    console.log('FormData status set edildi:', kursSatis.status !== undefined ? parseInt(kursSatis.status) : 1);
    setOgrenciSearchTerm('');
    setOgretmenSearchTerm('');
    setDersSearchTerm('');
    setShowOgrenciDropdown(false);
    setShowOgretmenDropdown(false);
    setShowDersDropdown(false);
    setIsFormOpen(true);
  };

  const closeForm = () => {
    console.log('Form kapatılıyor, mevcut formData.status:', formData.status);
    setIsFormOpen(false);
    setCurrentKursSatis(null);
    setFormData({
      musteri_id: '',
      ogretmenler: [],
      dersler: [],
      odeme_sikligi: 'Aylık',
      varsayilan_odeme_kanali: '',
      ders_ucret: '',
      sirket_adi: '',
      sirket_payi: 0,
      danisman1: '',
      danisman2: '',
      danisman3: '',
      danisman1_payi: 0,
      danisman2_payi: 0,
      danisman3_payi: 0,
      notlar: '',
      status: 1
    });
    setOgrenciSearchTerm('');
    setOgretmenSearchTerm('');
    setDersSearchTerm('');
    setShowOgrenciDropdown(false);
    setShowOgretmenDropdown(false);
    setShowDersDropdown(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    console.log('Submit başlangıç - formData.status:', formData.status, 'Tipi:', typeof formData.status);
    
    if (!formData.musteri_id || !formData.odeme_sikligi || !formData.ders_ucret) {
      alert('Lütfen zorunlu alanları doldurunuz.\n\n• Öğrenci seçimi\n• Ödeme sıklığı\n• Öğretmen ücreti\n\nalanları zorunludur.');
      return;
    }

    const parsedDersUcret = parseMoneyInput(formData.ders_ucret);
    if (Number.isNaN(parsedDersUcret)) {
      alert('Öğretmen ücreti için geçerli bir tutar giriniz (ör. 50,75 veya 50.75).');
      return;
    }

    try {
      const payload = {
        ...formData,
        ogretmenler: formData.ogretmenler.map(id => Number(id)),
        dersler: formData.dersler.map(id => Number(id)),
        ders_ucret: parseMoneyInput(formData.ders_ucret),
        sirket_adi: formData.sirket_adi ? Number(formData.sirket_adi) : null,  // Şirket ID'sini gönder
        sirket_payi: parseMoneyInput(formData.sirket_payi || 0) || 0,
        danisman1_payi: parseMoneyInput(formData.danisman1_payi || 0) || 0,
        danisman2_payi: parseMoneyInput(formData.danisman2_payi || 0) || 0,
        danisman3_payi: parseMoneyInput(formData.danisman3_payi || 0) || 0,
        status: formData.status !== undefined && formData.status !== null ? parseInt(formData.status) : 1  // Status değerini integer olarak gönder, yoksa 1 (aktif)
      };

      console.log('Gönderilen payload:', payload);  // Debug için
      console.log('Status tipi:', typeof payload.status);
      console.log('Status değeri:', payload.status);

      if (currentKursSatis) {
        const response = await axiosConfig.put(`/admin/kurssatis/${currentKursSatis.id}`, payload);
        console.log('Güncelleme yanıtı:', response.data);
      } else {
        const response = await axiosConfig.post('/admin/kurssatis', payload);
        console.log('Ekleme yanıtı:', response.data);
      }
      await fetchAllData();
      closeForm();
    } catch (error) {
      console.error('Submit error:', error);
      
      // Detaylı hata mesajı göster
      let errorMessage = 'İşlem sırasında bir hata oluştu.';
      if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
        if (error.response.data.details) {
          errorMessage += '\n\n' + error.response.data.details;
        }
      }
      alert(errorMessage);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Bu kurs satışını silmek istediğinize emin misiniz?\n\nBu işlem geri alınamaz.')) return;
    try {
      await axiosConfig.delete(`/admin/kurssatis/${id}`);
      await fetchAllData();
    } catch (error) {
      console.error('Delete error:', error);
      
      let errorMessage = 'Silme işlemi sırasında bir hata oluştu.';
      if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
        if (error.response.data.details) {
          errorMessage += '\n\n' + error.response.data.details;
        }
      }
      alert(errorMessage);
    }
  };

  const handleBatchDelete = async () => {
    if (selectedIds.length === 0) return;
    if (!window.confirm(`${selectedIds.length} adet kurs satışını silmek istediğinize emin misiniz?\n\nBu işlem geri alınamaz.`)) return;
    try {
      await axiosConfig.post('/admin/kurssatis/batch-delete', { ids: selectedIds });
      await fetchAllData();
      setSelectedIds([]);
      alert(`${selectedIds.length} adet kayıt başarıyla silindi.`);
    } catch (error) {
      console.error('Batch delete error:', error);
      const message =
        error.response?.data?.message ||
        'Toplu silme işlemi sırasında bir hata oluştu.\n\nBazı kayıtlar başka tablolarla ilişkili olabilir.';
      alert(message);
    }
  };

  const handleSelectChange = (id) => {
    setSelectedIds(prev =>
      prev.includes(id) ? prev.filter(selId => selId !== id) : [...prev, id]
    );
  };

  const handleSelectAll = (e) => {
    if (e.target.checked && Array.isArray(filteredKursSatislar)) {
      // Sadece görünen sayfadaki öğeleri seç
      const pageIds = filteredKursSatislar.map(k => k.id);
      setSelectedIds(prevIds => {
        // Daha önce seçilmiş olan diğer sayfalardaki ID'leri koru
        const otherPageIds = prevIds.filter(id => !pageIds.includes(id));
        return e.target.checked ? [...otherPageIds, ...pageIds] : otherPageIds;
      });
    } else {
      // Sadece bu sayfadaki seçimleri kaldır
      const pageIds = filteredKursSatislar.map(k => k.id);
      setSelectedIds(prevIds => prevIds.filter(id => !pageIds.includes(id)));
    }
  };

  const toggleOgretmenSelection = (ogretmenId) => {
    setFormData(prev => ({
      ...prev,
      ogretmenler: prev.ogretmenler.includes(ogretmenId)
        ? prev.ogretmenler.filter(id => id !== ogretmenId)
        : [...prev.ogretmenler, ogretmenId]
    }));
  };

  const toggleDersSelection = (dersId) => {
    setFormData(prev => ({
      ...prev,
      dersler: prev.dersler.includes(dersId)
        ? prev.dersler.filter(id => id !== dersId)
        : [...prev.dersler, dersId]
    }));
  };

  const calculateTotal = (kursSatis) => {
    return (
      parseFloat(kursSatis.ders_ucret || 0) +
      parseFloat(kursSatis.sirket_payi || 0) +
      parseFloat(kursSatis.danisman1_payi || 0) +
      parseFloat(kursSatis.danisman2_payi || 0) +
      parseFloat(kursSatis.danisman3_payi || 0)
    );
  };

  const calculateFormTotal = () => {
    const toNum = (v) => {
      const n = parseMoneyInput(v || 0);
      return Number.isFinite(n) ? n : 0;
    };
    return (
      toNum(formData.ders_ucret) +
      toNum(formData.sirket_payi) +
      toNum(formData.danisman1_payi) +
      toNum(formData.danisman2_payi) +
      toNum(formData.danisman3_payi)
    );
  };

  const clearAllFilters = () => {
    setSearchTerm('');
    setFilterOgrenci('');
    setFilterOgretmen('');
    setFilterDers('');
    setFilterOdemeSekli('all');
    setFilterStatus('all');
    setStartDate('');
    setEndDate('');
  };

  // Filtrele
  console.log('🔥🔥🔥 FİLTRELEME ÖNCESİ kursSatislar.length:', kursSatislar.length);
  console.log('Aktif Filtreler:', {
    searchTerm,
    filterOgrenci,
    filterOgretmen,
    filterDers,
    filterOdemeSekli,
    filterStatus,
    startDate,
    endDate
  });
  
  const allFilteredKursSatislar = Array.isArray(kursSatislar) ? kursSatislar.filter(kurs => {
    const matchesSearch = 
      kurs.musteri_adi?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      kurs.notlar?.toLowerCase().includes(searchTerm.toLowerCase());

    // 🔍 DEBUG: Öğrenci filtreleme kontrolü
    if (filterOgrenci) {
      console.log('🎯 Öğrenci Filter Debug:', {
        filterOgrenci: filterOgrenci,
        filterType: typeof filterOgrenci,
        kurs_musteri_id: kurs.musteri_id,
        kurs_musteri_type: typeof kurs.musteri_id,
        kurs_musteri_adi: kurs.musteri_adi,
        comparison1: kurs.musteri_id == filterOgrenci,
        comparison2: String(kurs.musteri_id) === String(filterOgrenci),
        comparison3: parseInt(kurs.musteri_id) === parseInt(filterOgrenci)
      });
    }

    // Öğrenci filtresi - HER ZAMAN string olarak karşılaştır
    const matchesOgrenci = !filterOgrenci || 
      String(kurs.musteri_id) === String(filterOgrenci);

    // Öğretmen filtresi - array içinde hem string hem number kontrolü
    const matchesOgretmen = !filterOgretmen || 
      (Array.isArray(kurs.ogretmenler) && 
       (kurs.ogretmenler.includes(parseInt(filterOgretmen)) || 
        kurs.ogretmenler.includes(filterOgretmen.toString()) ||
        kurs.ogretmenler.some(id => id == filterOgretmen)));

    // Ders filtresi - array içinde hem string hem number kontrolü  
    const matchesDers = !filterDers || 
      (Array.isArray(kurs.dersler) && 
       (kurs.dersler.includes(parseInt(filterDers)) || 
        kurs.dersler.includes(filterDers.toString()) ||
        kurs.dersler.some(id => id == filterDers)));

    const matchesOdemeSekli = filterOdemeSekli === 'all' || kurs.odeme_sikligi === filterOdemeSekli;

    const matchesStatus = filterStatus === 'all' || 
      (filterStatus === '1' && parseInt(kurs.status) === 1) ||
      (filterStatus === '0' && parseInt(kurs.status) === 0);

    // Tarih filtresi
    let matchesDateRange = true;
    if (startDate && kurs.created_at) {
      const kursDate = new Date(kurs.created_at);
      kursDate.setHours(0, 0, 0, 0);
      const sDate = new Date(startDate);
      sDate.setHours(0, 0, 0, 0);
      if (kursDate < sDate) matchesDateRange = false;
    }
    if (endDate && kurs.created_at) {
      const kursDate = new Date(kurs.created_at);
      kursDate.setHours(23, 59, 59, 999);
      const eDate = new Date(endDate);
      eDate.setHours(23, 59, 59, 999);
      if (kursDate > eDate) matchesDateRange = false;
    }

    const result = matchesSearch && matchesOgrenci && matchesOgretmen && matchesDers && matchesOdemeSekli && matchesStatus && matchesDateRange;
    
    // İlk 5 kayıt için detaylı debug
    if (kursSatislar.indexOf(kurs) < 5) {
      console.log(`Kayıt #${kurs.id} filtre sonuçları:`, {
        matchesSearch,
        matchesOgrenci,
        matchesOgretmen,
        matchesDers,
        matchesOdemeSekli,
        matchesStatus,
        matchesDateRange,
        SONUÇ: result
      });
    }
    
    return result;
  }) : [];
  
  console.log('🔥🔥🔥 FİLTRELEME SONRASI allFilteredKursSatislar.length:', allFilteredKursSatislar.length);
  
  // Sayfalama için hesaplamalar
  const startIndex = (currentPage - 1) * perPage;
  const endIndex = Math.min(startIndex + perPage, allFilteredKursSatislar.length);
  const filteredKursSatislar = allFilteredKursSatislar.slice(startIndex, endIndex);
  
  // Toplam sayfa sayısını hesapla
  useEffect(() => {
    const total = Math.ceil(allFilteredKursSatislar.length / perPage);
    setTotalPages(total);
    setTotalCount(allFilteredKursSatislar.length);
    
    // Eğer mevcut sayfa toplam sayfadan büyükse, ilk sayfaya dön
    if (currentPage > total && total > 0) {
      setCurrentPage(1);
    }
  }, [allFilteredKursSatislar.length, perPage, currentPage]);

  const activeFiltersCount = [
    searchTerm,
    filterOgrenci,
    filterOgretmen,
    filterDers,
    filterOdemeSekli !== 'all',
    filterStatus !== 'all',
    startDate,
    endDate
  ].filter(Boolean).length;

  const allFilteredSelected = 
    Array.isArray(filteredKursSatislar) && filteredKursSatislar.length > 0 && selectedIds.length === filteredKursSatislar.length;
  
  // Sayfa değiştirme fonksiyonları
  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages && page !== currentPage) {
      setCurrentPage(page);
      setSelectedIds([]); // Sayfa değiştiğinde seçimleri temizle
    }
  };
  
  const goToFirstPage = () => goToPage(1);
  const goToLastPage = () => goToPage(totalPages);
  const goToPrevPage = () => goToPage(currentPage - 1);
  const goToNextPage = () => goToPage(currentPage + 1);
  
  // Sayfa başına kayıt sayısı değiştirme
  const handlePerPageChange = (newPerPage) => {
    setPerPage(parseInt(newPerPage));
    setCurrentPage(1);
    setSelectedIds([]);
  };
  
  // Sayfa numaraları dizisi oluştur
  const getPageNumbers = () => {
    const delta = 2;
    const range = [];
    const rangeWithDots = [];
    let l;

    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= currentPage - delta && i <= currentPage + delta)) {
        range.push(i);
      }
    }

    range.forEach((i) => {
      if (l) {
        if (i - l === 2) {
          rangeWithDots.push(l + 1);
        } else if (i - l !== 1) {
          rangeWithDots.push('...');
        }
      }
      rangeWithDots.push(i);
      l = i;
    });

    return rangeWithDots;
  };

  const getOgretmenNames = (ogretmenIds) => {
    if (!Array.isArray(ogretmenIds) || !Array.isArray(teachers)) return '-';
    return ogretmenIds
      .map(id => {
        // Hem == hem === ile kontrol et, tip dönüşümü için
        const teacher = teachers.find(t => t.id == id || t.id === Number(id) || t.id === String(id));
        return teacher ? teacher.adi : '';
      })
      .filter(name => name)
      .join(', ') || '-';
  };

  const getDersNames = (dersIds) => {
    if (!Array.isArray(dersIds) || !Array.isArray(lessonGroups)) return '-';
    return dersIds
      .map(id => {
        // Hem == hem === ile kontrol et, tip dönüşümü için
        const lesson = lessonGroups.find(l => l.id == id || l.id === Number(id) || l.id === String(id));
        return lesson ? lesson.ders_adi : '';
      })
      .filter(name => name)
      .join(', ') || '-';
  };

  const getSelectedOgretmenNames = () => {
    if (!Array.isArray(teachers)) return '';
    return formData.ogretmenler
      .map(id => teachers.find(t => t.id === id)?.adi)
      .filter(name => name)
      .join(', ');
  };

  const getSelectedDersNames = () => {
    if (!Array.isArray(lessonGroups)) return '';
    return formData.dersler
      .map(id => lessonGroups.find(l => l.id === id)?.ders_adi)
      .filter(name => name)
      .join(', ');
  };
  
  // Filter functions for form dropdowns
  const filteredStudentsForForm = Array.isArray(students) ? students.filter(student =>
    student.name?.toLowerCase().includes(ogrenciSearchTerm.toLowerCase())
  ) : [];
  
  const filteredTeachersForForm = Array.isArray(teachers) ? teachers.filter(teacher =>
    teacher.adi?.toLowerCase().includes(ogretmenSearchTerm.toLowerCase())
  ) : [];
  
  const filteredLessonsForForm = Array.isArray(lessonGroups) ? lessonGroups.filter(lesson =>
    lesson.ders_adi?.toLowerCase().includes(dersSearchTerm.toLowerCase())
  ) : [];
  
  // Get selected student name
  const selectedStudentName = Array.isArray(students) ? students.find(s => s.id == formData.musteri_id)?.name || '' : '';

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
          <p className="mt-4 text-slate-600">Yükleniyor...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-100 p-2 sm:p-4 lg:p-6">
      <div className="w-full bg-white p-3 sm:p-4 lg:p-6 rounded-xl shadow-xl">
        {/* Üst Bar */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6 gap-4">
          <h2 className="text-3xl font-bold text-slate-800 flex items-center gap-2">
            Kurs Satış Yönetimi
            <span className="px-3 py-1 bg-blue-100 text-blue-700 text-sm rounded-full">
              Bugün {dailySalesCount} satış
            </span>
            {filterStatus === '0' && (
              <span className="px-3 py-1 bg-red-100 text-red-700 text-sm rounded-full">
                Pasif Kayıtlar
              </span>
            )}
          </h2>
          <div className="flex gap-3">
            <button
              className="bg-red-600 text-white px-4 py-2.5 rounded-lg hover:bg-red-700 disabled:opacity-60 disabled:cursor-not-allowed flex items-center gap-2"
              onClick={handleBatchDelete}
              disabled={selectedIds.length === 0}
            >
              Seçili Sil ({selectedIds.length})
            </button>
            <button
              className="bg-indigo-600 text-white px-4 py-2.5 rounded-lg hover:bg-indigo-700 flex items-center gap-2"
              onClick={openFormForCreate}
            >
              Yeni Kurs Satışı
            </button>
          </div>
        </div>

        {/* Geliştirilmiş Filtreler */}
        <div className="bg-gradient-to-br from-slate-50 to-slate-100 rounded-xl p-6 mb-6 border border-slate-200 shadow-sm">
          <div className="flex items-center justify-between mb-5">
            <h3 className="text-xl font-bold text-slate-800 flex items-center gap-3">
              <div className="p-2 bg-white rounded-lg shadow-sm">
                <svg className="w-5 h-5 text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
                </svg>
              </div>
              Filtreler
              {activeFiltersCount > 0 && (
                <span className="px-3 py-1 text-sm bg-indigo-100 text-indigo-700 rounded-full font-medium">
                  {activeFiltersCount} aktif
                </span>
              )}
              {totalCount > 0 && (
                <span className="ml-auto text-sm text-slate-600 font-medium">
                  Toplam <span className="text-indigo-600 font-bold">{totalCount}</span> sonuç
                </span>
              )}
            </h3>
            {activeFiltersCount > 0 && (
              <button
                onClick={clearAllFilters}
                className="px-4 py-2 text-sm bg-red-50 text-red-600 hover:bg-red-100 font-medium rounded-lg transition-colors"
              >
                ✕ Tümünü Temizle
              </button>
            )}
          </div>

          {/* Ana Filtreler - İlk Satır */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
            {/* Arama */}
            <div className="space-y-2">
              <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
                <svg className="w-4 h-4 text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
                Genel Arama
              </label>
              <div className="relative">
                <input
                  type="text"
                  className="w-full pl-10 pr-4 py-3 bg-white border border-slate-300 rounded-lg shadow-sm text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all"
                  placeholder="Kurs adı, not, vb. ara..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <svg className="absolute left-3 top-3.5 w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </div>
            </div>

            {/* Öğrenci filtresi - Searchable */}
            <div className="space-y-2">
              <label className="text-sm font-semibold text-slate-700">Öğrenci</label>
              <SearchableSelect
                options={[{ id: '', name: 'Tüm Öğrenciler' }, ...students]}
                value={filterOgrenci}
                onChange={(e) => {
                  console.log('🎯 Öğrenci seçildi:', {
                    value: e.target.value,
                    type: typeof e.target.value,
                    parsed: parseInt(e.target.value)
                  });
                  // Her zaman string olarak kaydet
                  setFilterOgrenci(String(e.target.value));
                }}
                placeholder="Öğrenci seç veya ara..."
                displayKey="name"
                valueKey="id"
                iconType="user"
              />
            </div>

            {/* Öğretmen filtresi - Searchable */}
            <div className="space-y-2">
              <label className="text-sm font-semibold text-slate-700">Öğretmen</label>
              <SearchableSelect
                options={[{ id: '', adi: 'Tüm Öğretmenler' }, ...teachers]}
                value={filterOgretmen}
                onChange={(e) => setFilterOgretmen(e.target.value)}
                placeholder="Öğretmen seç veya ara..."
                displayKey="adi"
                valueKey="id"
                iconType="teacher"
              />
            </div>

            {/* Ders filtresi - Searchable */}
            <div className="space-y-2">
              <label className="text-sm font-semibold text-slate-700">Ders</label>
              <SearchableSelect
                options={[{ id: '', ders_adi: 'Tüm Dersler' }, ...lessonGroups]}
                value={filterDers}
                onChange={(e) => setFilterDers(e.target.value)}
                placeholder="Ders seç veya ara..."
                displayKey="ders_adi"
                valueKey="id"
              />
            </div>
          </div>

          {/* İkinci Satır Filtreler */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {/* Ödeme sıklığı filtresi */}
            <div className="space-y-2">
              <label className="text-sm font-semibold text-slate-700">Ödeme Tipi</label>
              <select
                className="w-full px-4 py-3 bg-white border border-slate-300 rounded-lg shadow-sm text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all"
                value={filterOdemeSekli}
                onChange={(e) => setFilterOdemeSekli(e.target.value)}
              >
                <option value="all">Tüm Ödeme Tipleri</option>
                <option value="Aylık">Aylık</option>
                <option value="Yıllık">Yıllık</option>
                <option value="Tek Seferlik">Tek Seferlik</option>
              </select>
            </div>

            {/* Durum filtresi */}
            <div className="space-y-2">
              <label className="text-sm font-semibold text-slate-700">Durum</label>
              <select
                className="w-full px-4 py-3 bg-white border border-slate-300 rounded-lg shadow-sm text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all"
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
              >
                <option value="all">Tüm Durumlar</option>
                <option value="1">Aktif</option>
                <option value="0">Pasif</option>
              </select>
            </div>

            {/* Başlangıç tarihi */}
            <div className="space-y-2">
              <label className="text-sm font-semibold text-slate-700">Başlangıç Tarihi</label>
              <input
                type="date"
                className="w-full px-4 py-3 bg-white border border-slate-300 rounded-lg shadow-sm text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>

            {/* Bitiş tarihi */}
            <div className="space-y-2">
              <label className="text-sm font-semibold text-slate-700">Bitiş Tarihi</label>
              <input
                type="date"
                className="w-full px-4 py-3 bg-white border border-slate-300 rounded-lg shadow-sm text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
          </div>

          {/* Aktif filtre etiketleri */}
          {activeFiltersCount > 0 && (
            <div className="mt-3 flex flex-wrap gap-2">
              {searchTerm && (
                <span className="inline-flex items-center px-3 py-1 bg-indigo-100 text-indigo-700 text-sm rounded-full">
                  Arama: {searchTerm}
                  <button onClick={() => setSearchTerm('')} className="ml-2 hover:text-indigo-900">
                    <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </button>
                </span>
              )}
              {filterOgrenci && (
                <span className="inline-flex items-center px-3 py-1 bg-indigo-100 text-indigo-700 text-sm rounded-full">
                  Öğrenci: {Array.isArray(students) ? students.find(s => s.id === parseInt(filterOgrenci))?.name : '-'}
                  <button onClick={() => setFilterOgrenci('')} className="ml-2 hover:text-indigo-900">
                    <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </button>
                </span>
              )}
              {filterOdemeSekli !== 'all' && (
                <span className="inline-flex items-center px-3 py-1 bg-indigo-100 text-indigo-700 text-sm rounded-full">
                  Ödeme: {filterOdemeSekli}
                  <button onClick={() => setFilterOdemeSekli('all')} className="ml-2 hover:text-indigo-900">
                    <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </button>
                </span>
              )}
              {filterStatus !== 'all' && (
                <span className="inline-flex items-center px-3 py-1 bg-indigo-100 text-indigo-700 text-sm rounded-full">
                  Durum: {filterStatus === '1' ? 'Aktif' : 'Pasif'}
                  <button onClick={() => setFilterStatus('all')} className="ml-2 hover:text-indigo-900">
                    <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </button>
                </span>
              )}
            </div>
          )}
        </div>

        {/* Üst Sayfalama Kontrolleri */}
        {totalPages > 0 && (
          <div className="mb-4 px-4 py-3 bg-slate-50 border border-slate-200 rounded-lg">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              {/* Sol: Bilgi ve Sayfa Başına Kayıt */}
              <div className="flex items-center gap-4">
                <p className="text-sm text-slate-700">
                  Toplam <span className="font-semibold">{totalCount}</span> kayıttan{' '}
                  <span className="font-semibold">{startIndex + 1}</span> -{' '}
                  <span className="font-semibold">{Math.min(endIndex, totalCount)}</span> arası gösteriliyor
                </p>
                
                <div className="flex items-center gap-2">
                  <label className="text-sm text-slate-600">Sayfa başına:</label>
                  <select
                    className="px-3 py-1.5 border border-slate-300 rounded-md text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                    value={perPage}
                    onChange={(e) => handlePerPageChange(e.target.value)}
                  >
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
              </div>
              
              {/* Sağ: Sayfalama Butonları */}
              <nav className="flex items-center space-x-1">
                <button
                  onClick={goToFirstPage}
                  disabled={currentPage === 1}
                  className="p-2 rounded-lg border border-slate-300 bg-white hover:bg-slate-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                  title="İlk Sayfa"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 19l-7-7 7-7m8 14l-7-7 7-7" />
                  </svg>
                </button>
                
                <button
                  onClick={goToPrevPage}
                  disabled={currentPage === 1}
                  className="p-2 rounded-lg border border-slate-300 bg-white hover:bg-slate-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                  title="Önceki Sayfa"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                </button>
                
                {/* Sayfa numaraları */}
                {getPageNumbers().map((number, index) => {
                  if (number === '...') {
                    return (
                      <span key={index} className="px-3 py-2 text-slate-500">
                        ...
                      </span>
                    );
                  }
                  return (
                    <button
                      key={number}
                      onClick={() => goToPage(number)}
                      className={`px-3 py-2 rounded-lg border transition-colors ${
                        currentPage === number
                          ? 'bg-indigo-600 text-white border-indigo-600'
                          : 'border-slate-300 bg-white hover:bg-slate-100'
                      }`}
                    >
                      {number}
                    </button>
                  );
                })}
                
                <button
                  onClick={goToNextPage}
                  disabled={currentPage === totalPages}
                  className="p-2 rounded-lg border border-slate-300 bg-white hover:bg-slate-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                  title="Sonraki Sayfa"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </button>
                
                <button
                  onClick={goToLastPage}
                  disabled={currentPage === totalPages}
                  className="p-2 rounded-lg border border-slate-300 bg-white hover:bg-slate-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                  title="Son Sayfa"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 5l7 7-7 7M5 5l7 7-7 7" />
                  </svg>
                </button>
              </nav>
            </div>
          </div>
        )}

        {/* Tablo */}
        <div className="overflow-x-auto rounded-lg border border-slate-200 shadow-sm">
          <table className="w-full min-w-max table-auto">
            <thead className="bg-slate-100">
              <tr className="text-slate-600 uppercase text-xs font-semibold tracking-wider">
                <th className="px-4 py-3 text-center border-b border-slate-200">
                  <input
                    type="checkbox"
                    className="form-checkbox h-4 w-4 text-indigo-600 border-slate-300 rounded focus:ring-indigo-500"
                    checked={allFilteredSelected}
                    onChange={handleSelectAll}
                    disabled={!Array.isArray(filteredKursSatislar) || filteredKursSatislar.length === 0}
                  />
                </th>
                <th className="px-4 py-3 text-left border-b border-slate-200">Müşteri</th>
                <th className="px-4 py-3 text-left border-b border-slate-200">Durum</th>
                <th className="px-4 py-3 text-left border-b border-slate-200">Öğretmenler</th>
                <th className="px-4 py-3 text-left border-b border-slate-200">Dersler</th>
                <th className="px-4 py-3 text-left border-b border-slate-200">Ödeme Sıklığı</th>
                <th className="px-4 py-3 text-right border-b border-slate-200">Öğretmen Ücreti</th>
                <th className="px-4 py-3 text-left border-b border-slate-200">Şirket Bilgileri</th>
                <th className="px-4 py-3 text-right border-b border-slate-200">Danışman-1</th>
                <th className="px-4 py-3 text-right border-b border-slate-200">Danışman-2</th>
                <th className="px-4 py-3 text-right border-b border-slate-200">Danışman-3</th>
                <th className="px-4 py-3 text-right border-b border-slate-200">Toplam</th>
                <th className="px-4 py-3 text-left border-b border-slate-200">Notlar</th>
                <th className="px-4 py-3 text-left border-b border-slate-200">İşlemler</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-slate-200">
              {Array.isArray(filteredKursSatislar) && filteredKursSatislar.map(kurs => {
                const isSelected = selectedIds.includes(kurs.id);
                const total = calculateTotal(kurs);
                const isPassive = parseInt(kurs.status) === 0;

                return (
                  <tr
                    key={kurs.id}
                    className={`transition-all duration-150 ${
                      isPassive 
                        ? 'bg-red-50/50 hover:bg-red-100/50 opacity-75' 
                        : 'hover:bg-slate-50'
                    } ${isSelected ? 'bg-indigo-50' : ''}`}
                  >
                    <td className="px-4 py-3 text-center">
                      <input
                        type="checkbox"
                        className="form-checkbox h-4 w-4 text-indigo-600 border-slate-300 rounded focus:ring-indigo-500"
                        checked={isSelected}
                        onChange={() => handleSelectChange(kurs.id)}
                      />
                    </td>
                    <td className={`px-4 py-3 text-sm font-medium ${
                      isPassive ? 'text-red-900' : 'text-slate-700'
                    }`}>
                      {kurs.musteri_adi || '-'}
                    </td>
                    <td className="px-4 py-3">
                      <span className={`inline-flex items-center px-2 py-1 text-xs font-semibold rounded-full ${
                        isPassive 
                          ? 'bg-red-100 text-red-800 border border-red-200' 
                          : 'bg-green-100 text-green-800 border border-green-200'
                      }`}>
                        <span className={`w-2 h-2 rounded-full mr-1.5 ${
                          isPassive ? 'bg-red-400' : 'bg-green-400'
                        }`}></span>
                        {isPassive ? 'Pasif' : 'Aktif'}
                      </span>
                    </td>
                    <td className={`px-4 py-3 text-sm ${
                      isPassive ? 'text-red-800' : 'text-slate-600'
                    }`}>
                      <div className="max-w-xs truncate" title={getOgretmenNames(kurs.ogretmenler)}>
                        {getOgretmenNames(kurs.ogretmenler)}
                      </div>
                    </td>
                    <td className={`px-4 py-3 text-sm ${
                      isPassive ? 'text-red-800' : 'text-slate-600'
                    }`}>
                      <div className="max-w-xs truncate" title={getDersNames(kurs.dersler)}>
                        {getDersNames(kurs.dersler)}
                      </div>
                    </td>
                    <td className={`px-4 py-3 text-sm ${
                      isPassive ? 'text-red-800' : 'text-slate-600'
                    }`}>
                      <span className={`px-2 py-1 text-xs font-semibold rounded-full ${
                        kurs.odeme_sikligi === 'Aylık' ? 'bg-blue-100 text-blue-700' :
                        kurs.odeme_sikligi === 'Yıllık' ? 'bg-green-100 text-green-700' :
                        'bg-purple-100 text-purple-700'
                      }`}>
                        {kurs.odeme_sikligi}
                      </span>
                    </td>
                    <td className={`px-4 py-3 text-sm text-right font-medium ${
                      isPassive ? 'text-red-900' : 'text-slate-700'
                    }`}>
                      ₺{parseFloat(kurs.ders_ucret || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 })}
                    </td>
                    <td className={`px-4 py-3 text-sm ${
                      isPassive ? 'text-red-800' : 'text-slate-600'
                    }`}>
                      {kurs.sirket_adi ? (
                        <div>
                          <div className="font-medium">{kurs.sirket_adi}</div>
                          {kurs.sirket_payi > 0 && (
                            <div className="text-xs text-slate-500">
                              ₺{parseFloat(kurs.sirket_payi).toLocaleString('tr-TR', { minimumFractionDigits: 2 })}
                            </div>
                          )}
                        </div>
                      ) : '-'}
                    </td>
                    <td className={`px-4 py-3 text-sm text-right ${
                      isPassive ? 'text-red-800' : 'text-slate-600'
                    }`}>
                      {kurs.danisman1_adi ? (
                        <div>
                          <div className="text-xs">{kurs.danisman1_adi}</div>
                          <div className="font-medium">
                            ₺{parseFloat(kurs.danisman1_payi || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 })}
                          </div>
                        </div>
                      ) : '-'}
                    </td>
                    <td className={`px-4 py-3 text-sm text-right ${
                      isPassive ? 'text-red-800' : 'text-slate-600'
                    }`}>
                      {kurs.danisman2_adi ? (
                        <div>
                          <div className="text-xs">{kurs.danisman2_adi}</div>
                          <div className="font-medium">
                            ₺{parseFloat(kurs.danisman2_payi || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 })}
                          </div>
                        </div>
                      ) : '-'}
                    </td>
                    <td className={`px-4 py-3 text-sm text-right ${
                      isPassive ? 'text-red-800' : 'text-slate-600'
                    }`}>
                      {kurs.danisman3_adi ? (
                        <div>
                          <div className="text-xs">{kurs.danisman3_adi}</div>
                          <div className="font-medium">
                            ₺{parseFloat(kurs.danisman3_payi || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 })}
                          </div>
                        </div>
                      ) : '-'}
                    </td>
                    <td className="px-4 py-3 text-sm text-right">
                      <span className={`font-bold ${
                        isPassive ? 'text-red-600' : 'text-indigo-600'
                      }`}>
                        ₺{total.toLocaleString('tr-TR', { minimumFractionDigits: 2 })}
                      </span>
                    </td>
                    <td className={`px-4 py-3 text-sm ${
                      isPassive ? 'text-red-800' : 'text-slate-600'
                    }`}>
                      <div className="max-w-xs truncate" title={kurs.notlar}>
                        {kurs.notlar || '-'}
                      </div>
                    </td>
                    <td className={`px-4 py-3 text-sm whitespace-nowrap ${
                      isPassive ? 'text-red-800' : 'text-slate-600'
                    }`}>
                      <button
                        className={`mr-3 font-medium ${
                          isPassive 
                            ? 'text-orange-600 hover:text-orange-800' 
                            : 'text-indigo-600 hover:text-indigo-800'
                        }`}
                        onClick={() => openFormForEdit(kurs)}
                      >
                        Düzenle
                      </button>
                      <button
                        className={`font-medium ${
                          isPassive 
                            ? 'text-red-800 hover:text-red-900' 
                            : 'text-red-600 hover:text-red-800'
                        }`}
                        onClick={() => handleDelete(kurs.id)}
                      >
                        Sil
                      </button>
                    </td>
                  </tr>
                );
              })}
              {(!Array.isArray(filteredKursSatislar) || filteredKursSatislar.length === 0) && (
                <tr>
                  <td colSpan="14" className="p-6 text-center text-slate-500 text-lg">
                    Kayıt bulunamadı.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        
        {/* Alt Sayfalama Kontrolleri */}
        {totalPages > 0 && (
          <div className="mt-4 px-4 py-3 bg-slate-50 border border-slate-200 rounded-lg">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              {/* Sol: Bilgi ve Sayfa Başına Kayıt */}
              <div className="flex items-center gap-4">
                <p className="text-sm text-slate-700">
                  Toplam <span className="font-semibold">{totalCount}</span> kayıttan{' '}
                  <span className="font-semibold">{startIndex + 1}</span> -{' '}
                  <span className="font-semibold">{Math.min(endIndex, totalCount)}</span> arası gösteriliyor
                </p>
                
                <div className="flex items-center gap-2">
                  <label className="text-sm text-slate-600">Sayfa başına:</label>
                  <select
                    className="px-3 py-1.5 border border-slate-300 rounded-md text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                    value={perPage}
                    onChange={(e) => handlePerPageChange(e.target.value)}
                  >
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
              </div>
              
              {/* Sağ: Sayfalama Butonları */}
              <nav className="flex items-center space-x-1">
                <button
                  onClick={goToFirstPage}
                  disabled={currentPage === 1}
                  className="p-2 rounded-lg border border-slate-300 bg-white hover:bg-slate-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                  title="İlk Sayfa"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 19l-7-7 7-7m8 14l-7-7 7-7" />
                  </svg>
                </button>
                
                <button
                  onClick={goToPrevPage}
                  disabled={currentPage === 1}
                  className="p-2 rounded-lg border border-slate-300 bg-white hover:bg-slate-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                  title="Önceki Sayfa"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                </button>
                
                {/* Sayfa numaraları */}
                {getPageNumbers().map((number, index) => {
                  if (number === '...') {
                    return (
                      <span key={index} className="px-3 py-2 text-slate-500">
                        ...
                      </span>
                    );
                  }
                  return (
                    <button
                      key={number}
                      onClick={() => goToPage(number)}
                      className={`px-3 py-2 rounded-lg border transition-colors ${
                        currentPage === number
                          ? 'bg-indigo-600 text-white border-indigo-600'
                          : 'border-slate-300 bg-white hover:bg-slate-100'
                      }`}
                    >
                      {number}
                    </button>
                  );
                })}
                
                <button
                  onClick={goToNextPage}
                  disabled={currentPage === totalPages}
                  className="p-2 rounded-lg border border-slate-300 bg-white hover:bg-slate-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                  title="Sonraki Sayfa"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </button>
                
                <button
                  onClick={goToLastPage}
                  disabled={currentPage === totalPages}
                  className="p-2 rounded-lg border border-slate-300 bg-white hover:bg-slate-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                  title="Son Sayfa"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 5l7 7-7 7M5 5l7 7-7 7" />
                  </svg>
                </button>
              </nav>
            </div>
          </div>
        )}
      </div>

      {/* Form Modal */}
      {isFormOpen && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-3 sm:p-4 z-50 transition-all duration-300">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-5xl max-h-[95vh] flex flex-col overflow-hidden transform transition-all duration-300 scale-100">
            {/* Modal Header */}
            <div className="flex justify-between items-center p-4 sm:p-6 border-b border-slate-200 bg-gradient-to-r from-indigo-50 to-blue-50">
              <div>
                <h3 className="text-xl sm:text-2xl font-bold text-slate-800">
                  {currentKursSatis ? 'Kurs Satışını Düzenle' : 'Yeni Kurs Satışı Ekle'}
                </h3>
                <p className="text-sm text-slate-600 mt-1">
                  {currentKursSatis ? 'Kurs satış bilgilerini güncelleyin' : 'Yeni kurs satış bilgilerini girin'}
                </p>
              </div>
              <button 
                onClick={closeForm} 
                className="p-2 rounded-full hover:bg-slate-100 transition-colors duration-200 group"
              >
                <svg
                  className="h-6 w-6 text-slate-400 group-hover:text-slate-600 transition-colors"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Modal Body - Scrollable */}
            <div className="flex-1 overflow-y-auto">
              <form onSubmit={handleSubmit} className="p-4 sm:p-6">
                {/* Öğrenci ve Öğretmenler */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
                  <div className="relative" ref={ogrenciDropdownRef}>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">
                      Öğrenci <span className="text-red-500">*</span>
                    </label>
                    <button
                      type="button"
                      onClick={() => setShowOgrenciDropdown(!showOgrenciDropdown)}
                      className="w-full text-left bg-slate-50 border border-slate-300 rounded-lg shadow-sm px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all duration-200"
                    >
                      <span className={formData.musteri_id ? 'text-slate-700' : 'text-slate-400'}>
                        {selectedStudentName || 'Öğrenci seçiniz'}
                      </span>
                    </button>
                    
                    {showOgrenciDropdown && (
                      <div className="absolute z-10 mt-1 w-full bg-white border border-slate-200 rounded-md shadow-lg max-h-80 overflow-hidden">
                        <div className="p-2 border-b border-slate-200">
                          <div className="relative">
                            <input
                              type="text"
                              className="w-full pl-9 pr-9 py-2 text-sm bg-white border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                              placeholder="Öğrenci ara..."
                              value={ogrenciSearchTerm}
                              onChange={(e) => setOgrenciSearchTerm(e.target.value)}
                              onClick={(e) => e.stopPropagation()}
                            />
                            <svg className="absolute left-3 top-2.5 w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                            </svg>
                            {ogrenciSearchTerm && (
                              <button
                                type="button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setOgrenciSearchTerm('');
                                }}
                                className="absolute right-3 top-2.5 text-slate-400 hover:text-slate-600"
                              >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                              </button>
                            )}
                          </div>
                        </div>
                        <div className="max-h-60 overflow-y-auto">
                          {filteredStudentsForForm.length > 0 ? (
                            filteredStudentsForForm.map(student => (
                              <div
                                key={student.id}
                                className="px-3 py-2 hover:bg-slate-50 cursor-pointer text-sm"
                                onClick={() => {
                                  setFormData({ ...formData, musteri_id: student.id });
                                  setShowOgrenciDropdown(false);
                                  setOgrenciSearchTerm('');
                                }}
                              >
                                {student.name}
                              </div>
                            ))
                          ) : (
                            <div className="px-3 py-4 text-center text-slate-500">
                              <svg className="w-8 h-8 mx-auto text-slate-300 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                              </svg>
                              <p className="text-sm">Öğrenci bulunamadı</p>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="relative" ref={ogretmenDropdownRef}>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">
                      Öğretmen Adı
                    </label>
                    <button
                      type="button"
                      onClick={() => setShowOgretmenDropdown(!showOgretmenDropdown)}
                      className="w-full text-left bg-slate-50 border border-slate-300 rounded-lg shadow-sm px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all duration-200"
                    >
                      <span className={formData.ogretmenler.length === 0 ? 'text-slate-400' : 'text-slate-700'}>
                        {formData.ogretmenler.length === 0 
                          ? 'Öğretmen seçiniz' 
                          : getSelectedOgretmenNames() || `${formData.ogretmenler.length} öğretmen seçildi`
                        }
                      </span>
                    </button>
                    
                    {showOgretmenDropdown && (
                      <div className="absolute z-10 mt-1 w-full bg-white border border-slate-200 rounded-md shadow-lg max-h-80 overflow-hidden">
                        <div className="p-2 border-b border-slate-200">
                          <div className="relative mb-2">
                            <input
                              type="text"
                              className="w-full pl-9 pr-9 py-2 text-sm bg-white border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                              placeholder="Öğretmen ara..."
                              value={ogretmenSearchTerm}
                              onChange={(e) => setOgretmenSearchTerm(e.target.value)}
                              onClick={(e) => e.stopPropagation()}
                            />
                            <svg className="absolute left-3 top-2.5 w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                            </svg>
                            {ogretmenSearchTerm && (
                              <button
                                type="button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setOgretmenSearchTerm('');
                                }}
                                className="absolute right-3 top-2.5 text-slate-400 hover:text-slate-600"
                              >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                              </button>
                            )}
                          </div>
                          <button
                            type="button"
                            onClick={() => setFormData({ ...formData, ogretmenler: [] })}
                            className="w-full text-left px-3 py-1 text-sm text-indigo-600 hover:bg-indigo-50 rounded"
                          >
                            Tümünü Temizle
                          </button>
                        </div>
                        <div className="max-h-52 overflow-y-auto">
                          {filteredTeachersForForm.length > 0 ? (
                            filteredTeachersForForm.map(teacher => (
                              <label
                                key={teacher.id}
                                className="flex items-center px-3 py-2 hover:bg-slate-50 cursor-pointer"
                              >
                                <input
                                  type="checkbox"
                                  checked={formData.ogretmenler.includes(teacher.id)}
                                  onChange={() => toggleOgretmenSelection(teacher.id)}
                                  className="mr-3 h-4 w-4 text-indigo-600 border-slate-300 rounded focus:ring-indigo-500"
                                />
                                <span className="text-sm">{teacher.adi}</span>
                              </label>
                            ))
                          ) : (
                            <div className="px-3 py-4 text-center text-slate-500">
                              <svg className="w-8 h-8 mx-auto text-slate-300 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                              </svg>
                              <p className="text-sm">Öğretmen bulunamadı</p>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Dersler ve Ödeme Bilgileri */}
                <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 mb-6">
                  <div className="relative" ref={dersDropdownRef}>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">
                      Ders Seçiniz
                    </label>
                    <button
                      type="button"
                      onClick={() => setShowDersDropdown(!showDersDropdown)}
                      className="w-full text-left bg-slate-50 border border-slate-300 rounded-lg shadow-sm px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all duration-200"
                    >
                      <span className={formData.dersler.length === 0 ? 'text-slate-400' : 'text-slate-700'}>
                        {formData.dersler.length === 0 
                          ? 'Ders seçiniz' 
                          : getSelectedDersNames() || `${formData.dersler.length} ders seçildi`
                        }
                      </span>
                    </button>
                    
                    {showDersDropdown && (
                      <div className="absolute z-10 mt-1 w-full bg-white border border-slate-200 rounded-md shadow-lg max-h-80 overflow-hidden">
                        <div className="p-2 border-b border-slate-200">
                          <div className="relative mb-2">
                            <input
                              type="text"
                              className="w-full pl-9 pr-9 py-2 text-sm bg-white border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                              placeholder="Ders ara..."
                              value={dersSearchTerm}
                              onChange={(e) => setDersSearchTerm(e.target.value)}
                              onClick={(e) => e.stopPropagation()}
                            />
                            <svg className="absolute left-3 top-2.5 w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                            </svg>
                            {dersSearchTerm && (
                              <button
                                type="button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setDersSearchTerm('');
                                }}
                                className="absolute right-3 top-2.5 text-slate-400 hover:text-slate-600"
                              >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                              </button>
                            )}
                          </div>
                          <button
                            type="button"
                            onClick={() => setFormData({ ...formData, dersler: [] })}
                            className="w-full text-left px-3 py-1 text-sm text-indigo-600 hover:bg-indigo-50 rounded"
                          >
                            Tümünü Temizle
                          </button>
                        </div>
                        <div className="max-h-52 overflow-y-auto">
                          {filteredLessonsForForm.length > 0 ? (
                            filteredLessonsForForm.map(lesson => (
                              <label
                                key={lesson.id}
                                className="flex items-center px-3 py-2 hover:bg-slate-50 cursor-pointer"
                              >
                                <input
                                  type="checkbox"
                                  checked={formData.dersler.includes(lesson.id)}
                                  onChange={() => toggleDersSelection(lesson.id)}
                                  className="mr-3 h-4 w-4 text-indigo-600 border-slate-300 rounded focus:ring-indigo-500"
                                />
                                <span className="text-sm">{lesson.ders_adi}</span>
                              </label>
                            ))
                          ) : (
                            <div className="px-3 py-4 text-center text-slate-500">
                              <svg className="w-8 h-8 mx-auto text-slate-300 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                              </svg>
                              <p className="text-sm">Ders bulunamadı</p>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">
                      Ödeme Sıklığı <span className="text-red-500">*</span>
                    </label>
                    <select
                      className="w-full bg-slate-50 border border-slate-300 rounded-lg shadow-sm px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all duration-200"
                      value={formData.odeme_sikligi}
                      onChange={(e) => setFormData({ ...formData, odeme_sikligi: e.target.value })}
                      required
                    >
                      {odemeSikliklari.map(odeme => (
                        <option key={odeme.value} value={odeme.value}>{odeme.label}</option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">
                      Öğretmen Ücreti <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      inputMode="decimal"
                      className="w-full bg-slate-50 border border-slate-300 rounded-lg shadow-sm px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all duration-200"
                      value={formData.ders_ucret}
                      onChange={(e) => setFormData({ ...formData, ders_ucret: sanitizeMoneyInput(e.target.value) })}
                      placeholder="Örn: 250,50"
                      required
                    />
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">
                      Varsayılan Ödeme Kanalı
                    </label>
                    <input
                      type="text"
                      className="w-full bg-slate-50 border border-slate-300 rounded-lg shadow-sm px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all duration-200"
                      value={formData.varsayilan_odeme_kanali}
                      onChange={(e) => setFormData({ ...formData, varsayilan_odeme_kanali: e.target.value })}
                      placeholder="Ödeme kanalı bilgisi"
                    />
                  </div>
                </div>

                {/* Danışmanlar Bölümü */}
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
                  {/* Danışman 1 */}
                  <div className="bg-slate-50 rounded-lg p-4">
                    <label className="block mb-2 text-sm font-semibold text-slate-700">
                      Danışman - 1
                    </label>
                    <select
                      className="w-full bg-white border border-slate-300 rounded-lg shadow-sm px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all duration-200 mb-3"
                      value={formData.danisman1}
                      onChange={(e) => setFormData({ ...formData, danisman1: e.target.value })}
                    >
                      <option value="">Seçiniz</option>
                      {Array.isArray(consultants) && consultants.map(consultant => (
                        <option key={consultant.id} value={consultant.id}>{consultant.adsoyad}</option>
                      ))}
                    </select>
                    <label className="block mb-2 text-sm font-medium text-slate-600">
                      Danışman - 1 Payı:
                    </label>
                    <input
                      type="text"
                      inputMode="decimal"
                      className="w-full bg-white border border-slate-300 rounded-lg shadow-sm px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all duration-200"
                      value={formData.danisman1_payi}
                      onChange={(e) => setFormData({ ...formData, danisman1_payi: sanitizeMoneyInput(e.target.value) })}
                      placeholder="Örn: 50,75"
                    />
                  </div>

                  {/* Danışman 2 */}
                  <div className="bg-slate-50 rounded-lg p-4">
                    <label className="block mb-2 text-sm font-semibold text-slate-700">
                      Danışman - 2
                    </label>
                    <select
                      className="w-full bg-white border border-slate-300 rounded-lg shadow-sm px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all duration-200 mb-3"
                      value={formData.danisman2}
                      onChange={(e) => setFormData({ ...formData, danisman2: e.target.value })}
                    >
                      <option value="">Seçiniz</option>
                      {Array.isArray(consultants) && consultants.map(consultant => (
                        <option key={consultant.id} value={consultant.id}>{consultant.adsoyad}</option>
                      ))}
                    </select>
                    <label className="block mb-2 text-sm font-medium text-slate-600">
                      Danışman - 2 Payı:
                    </label>
                    <input
                      type="text"
                      inputMode="decimal"
                      className="w-full bg-white border border-slate-300 rounded-lg shadow-sm px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all duration-200"
                      value={formData.danisman2_payi}
                      onChange={(e) => setFormData({ ...formData, danisman2_payi: sanitizeMoneyInput(e.target.value) })}
                      placeholder="Örn: 50,75"
                    />
                  </div>

                  {/* Danışman 3 */}
                  <div className="bg-slate-50 rounded-lg p-4">
                    <label className="block mb-2 text-sm font-semibold text-slate-700">
                      Danışman - 3
                    </label>
                    <select
                      className="w-full bg-white border border-slate-300 rounded-lg shadow-sm px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all duration-200 mb-3"
                      value={formData.danisman3}
                      onChange={(e) => setFormData({ ...formData, danisman3: e.target.value })}
                    >
                      <option value="">Seçiniz</option>
                      {Array.isArray(consultants) && consultants.map(consultant => (
                        <option key={consultant.id} value={consultant.id}>{consultant.adsoyad}</option>
                      ))}
                    </select>
                    <label className="block mb-2 text-sm font-medium text-slate-600">
                      Danışman - 3 Payı:
                    </label>
                    <input
                      type="text"
                      inputMode="decimal"
                      className="w-full bg-white border border-slate-300 rounded-lg shadow-sm px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all duration-200"
                      value={formData.danisman3_payi}
                      onChange={(e) => setFormData({ ...formData, danisman3_payi: sanitizeMoneyInput(e.target.value) })}
                      placeholder="Örn: 50,75"
                    />
                  </div>
                </div>

                {/* Şirket Bilgileri */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">
                      Kayıt Edilen Sistem
                    </label>
                    <select
                      className="w-full bg-slate-50 border border-slate-300 rounded-lg shadow-sm px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all duration-200"
                      value={formData.sirket_adi}
                      onChange={(e) => setFormData({ ...formData, sirket_adi: e.target.value })}
                    >
                      <option value="">Şirket Seçiniz</option>
                      {Array.isArray(companies) && companies.map(company => (
                        <option key={company.id} value={company.id}>{company.sirket_adi}</option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">
                      Şirket Payı
                    </label>
                    <input
                      type="text"
                      inputMode="decimal"
                      className="w-full bg-slate-50 border border-slate-300 rounded-lg shadow-sm px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all duration-200"
                      value={formData.sirket_payi}
                      onChange={(e) => setFormData({ ...formData, sirket_payi: sanitizeMoneyInput(e.target.value) })}
                      placeholder="Örn: 50,75"
                    />
                  </div>
                </div>

                {/* Durum Seçimi */}
                <div className="mb-6">
                  <label className="block mb-2 text-sm font-semibold text-slate-700">
                    Kayıt Durumu
                  </label>
                  <div className="flex gap-4">
                    <label className="flex items-center cursor-pointer">
                      <input
                        type="radio"
                        name="status"
                        value="1"
                        checked={formData.status === 1}
                        onChange={() => {
                          console.log('Status Aktif seçildi');
                          setFormData({ ...formData, status: 1 });
                        }}
                        className="mr-2 text-indigo-600 focus:ring-indigo-500"
                      />
                      <span className="px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm font-medium">
                        Aktif
                      </span>
                    </label>
                    <label className="flex items-center cursor-pointer">
                      <input
                        type="radio"
                        name="status"
                        value="0"
                        checked={formData.status === 0}
                        onChange={() => {
                          console.log('Status Pasif seçildi');
                          setFormData({ ...formData, status: 0 });
                        }}
                        className="mr-2 text-indigo-600 focus:ring-indigo-500"
                      />
                      <span className="px-3 py-1 bg-red-100 text-red-800 rounded-full text-sm font-medium">
                        Pasif
                      </span>
                    </label>
                  </div>
                </div>

                {/* Açıklama */}
                <div className="mb-6">
                  <label className="block mb-2 text-sm font-semibold text-slate-700">
                    Açıklama
                  </label>
                  <textarea
                    className="w-full bg-slate-50 border border-slate-300 rounded-lg shadow-sm px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all duration-200 resize-none"
                    rows="3"
                    value={formData.notlar}
                    onChange={(e) => setFormData({ ...formData, notlar: e.target.value })}
                    placeholder="Ek bilgiler ve notlar..."
                  />
                </div>

                {/* Toplam Ücret Gösterimi */}
                <div className="bg-gradient-to-r from-indigo-50 to-blue-50 rounded-lg p-6 border border-indigo-200">
                  <div className="flex items-center justify-between mb-4">
                    <span className="text-lg font-semibold text-slate-700">Toplam Ücret Özeti</span>
                    <span className="text-2xl font-bold text-indigo-600">
                      ₺{calculateFormTotal().toLocaleString('tr-TR', { minimumFractionDigits: 2 })}
                    </span>
                  </div>
                  <div className="grid grid-cols-2 gap-3 text-sm">
                    <div className="flex justify-between">
                      <span className="text-slate-600">Öğretmen Ücreti:</span>
                      <span className="font-medium">₺{(parseMoneyInput(formData.ders_ucret || 0) || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 })}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-slate-600">Şirket Payı:</span>
                      <span className="font-medium">₺{(parseMoneyInput(formData.sirket_payi || 0) || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 })}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-slate-600">Danışman 1 Payı:</span>
                      <span className="font-medium">₺{(parseMoneyInput(formData.danisman1_payi || 0) || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 })}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-slate-600">Danışman 2 Payı:</span>
                      <span className="font-medium">₺{(parseMoneyInput(formData.danisman2_payi || 0) || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 })}</span>
                    </div>
                    <div className="flex justify-between col-span-2">
                      <span className="text-slate-600">Danışman 3 Payı:</span>
                      <span className="font-medium">₺{(parseMoneyInput(formData.danisman3_payi || 0) || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 })}</span>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            {/* Modal Footer */}
            <div className="border-t border-slate-200 bg-slate-50 px-4 sm:px-6 py-4">
              <div className="flex flex-col sm:flex-row justify-end gap-3">
                <button
                  type="button"
                  onClick={closeForm}
                  className="w-full sm:w-auto px-6 py-2.5 text-sm font-semibold text-slate-700 bg-white border border-slate-300 rounded-lg hover:bg-slate-50 hover:border-slate-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all duration-200"
                >
                  İptal
                </button>
                <button
                  type="submit"
                  form="kurssatis-form"
                  onClick={handleSubmit}
                  className="w-full sm:w-auto px-6 py-2.5 text-sm font-semibold text-white bg-gradient-to-r from-indigo-600 to-blue-600 rounded-lg hover:from-indigo-700 hover:to-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transform hover:scale-105 transition-all duration-200 shadow-lg"
                >
                  {currentKursSatis ? '✓ Değişiklikleri Kaydet' : '✓ EKLE'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default KursSatisListPage;
